import { c as _c } from "react/compiler-runtime";
import { V2_ENDPOINT } from "@/consts";
import { authenticatedFetch } from "@/lib/authenticatedFetch";
import { useQuery } from "@tanstack/react-query";
interface TriggerInfoResponse {
  emailAddress?: string;
  paymentLinkUrl?: string;
}
interface ApiResponse {
  code: number;
  message: string;
  data: TriggerInfoResponse;
}

/**
 * Fetches trigger-specific metadata for a published workflow.
 * Returns Pipedream-generated email for email triggers and payment link URL for AnySpend triggers.
 */
export function useTriggerInfo(workflowId, enabled) {
  const $ = _c(10);
  let t0;
  let t1;
  if ($[0] !== workflowId) {
    t0 = ["trigger-info", workflowId];
    t1 = async () => {
      if (!workflowId) {
        return null;
      }
      const response = await authenticatedFetch(`${V2_ENDPOINT}/v1/workflows/${workflowId}/trigger-info`);
      if (!response.ok) {
        throw new Error(`Failed to fetch trigger info: ${response.statusText}`);
      }
      const data = await response.json();
      if (data.code !== 0) {
        throw new Error(`API error: ${data.message}`);
      }
      return data.data;
    };
    $[0] = workflowId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = enabled && !!workflowId;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: 30000,
      gcTime: 300000,
      refetchOnWindowFocus: false
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const query = useQuery(t3);
  const t4 = query.data ?? null;
  let t5;
  if ($[7] !== query.isLoading || $[8] !== t4) {
    t5 = {
      triggerInfo: t4,
      isLoading: query.isLoading
    };
    $[7] = query.isLoading;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}